import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import common from './modules/common'
import transData from './modules/transData'
import hqData from './modules/hqData'
import mydata from './modules/mydata'
import mData from './modules/mData'
import pt from './modules/pt'
import order from './modules/order'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    common,
    transData,
    hqData,
    mydata,
    mData,
    pt,
    order
  },
  strict: debug,
  plugins: [
    createPersistedState({
      key: 'pcclient-pt-mall', // 存储的 key 名称
      paths: ['pt.groupActivityType', 'pt.groupActivityId'], // 持久化 pt 模块的字段
      storage: window.sessionStorage // 使用 sessionStorage，关闭浏览器后清除
    })
  ]
})
